import { NavItemType } from '~/types/menu';

import menu from './dashboard';

const menuItems: { items: NavItemType[] } = {
  items: [menu],
};

export default menuItems;
